import { ForbiddenError } from "../components";

const ForbiddenPage = () => {
  return <ForbiddenError />;
};

export { ForbiddenPage };
